module.exports = __webpack_public_path__ + "static/media/fh_my.3aec655b.png";